import { ChevronRight } from 'assets/icons';
import Badge from 'components/badge/badge';
import Button from 'components/button';
import SlideOverBody from 'components/SlideOver/component/body';
import SlideOverFooter from 'components/SlideOver/component/footer';
import SlideOverHeader from 'components/SlideOver/component/header';
import useSlideOver from 'components/SlideOver/useSlideOver';
import { dateToEpoch, dateToIsoString } from 'helper/helper';
import UseContext from 'hooks/useContext';
import { useState } from 'react';
import { toast } from 'react-toastify';
import ApiDataBase from 'server';
import SlideOverAddMissionConfirmation from './slideOverAddMissionConfirmation/slideOverAddMissionConfirmation';
import SlideOverAddMissionGeneral from './slideOverAddMissionGeneral/slideOverAddMissionGeneral';
import SlideOverAddMissionPlanningInvitationAttributionNotification from './slideOverAddMissionInvitationAttributionNotification/slideOverAddMissionInvitationAttributionNotification';
import SlideOverAddMissionMotif from './slideOverAddMissionMotif/slideOverAddMissionMotif';
import SlideOverAddMissionPlanning from './slideOverAddMissionPlanning/slideOverAddMissionPlanning';

const slideOverAddMission = () => {
  const { toggleSlideOver } = useSlideOver();
  const [isLoadingAddMission, setIsLoadingAddMission] = useState(false);
  const [page, setPage] = useState(1);
  const { dataCreateMission, setDataCreateMission } = UseContext();
  const token = localStorage.getItem('xsrfToken');
  const isNotEmptyObject = (obj) =>
    obj && typeof obj === 'object' && Object.keys(obj).length > 0;

  const isGeneralStepValid = Boolean(
    dataCreateMission.company &&
      dataCreateMission.qualification &&
      isNotEmptyObject(dataCreateMission.location) &&
      dataCreateMission.salary &&
      dataCreateMission.contact_name &&
      dataCreateMission.contact_poste
  );
  const isMotifStepValid = Boolean(
    dataCreateMission.motif && Object.keys(dataCreateMission.motif).length > 0
  );
  const isPlanningStepValid = Boolean(
    dataCreateMission.dateStart &&
      dataCreateMission.dateEnd &&
      dateToEpoch(new Date(dataCreateMission.dateEnd)) >=
        dateToEpoch(new Date(dataCreateMission.dateStart))
  );

  const canContinue =
    page === 1
      ? isGeneralStepValid
      : page === 2
      ? isMotifStepValid
      : page === 3
      ? isPlanningStepValid
      : true;

  const closeSlideOver = () => {
    toggleSlideOver();
    setDataCreateMission({
      company: null,
      activity: '',
      qualification: '',
      title: '',
      tools: [],
      licences: [],
      languages: [],
      contact_name: '',
      contact_poste: 'Responsable',
      location: '',
      dateStart: '',
      dateEnd: '',
      schedule: [],
      isScheduleCheck: true,
      isConfirmedSchedule: false,
      isScheduleRequired: false,
      users_invite: [],
      motif: '',
      other: '',
      other_interim: '',
      salary: '',
      inviteType: '',
      vivierStatus: [],
      vivierSelections: [],
      globalNotificationRequested: false,
      user_assigned: {},
    });
  };

  const submitAddMission = () => {
    setIsLoadingAddMission(true);
    const payload = { ...dataCreateMission };
    if (payload.dateStart) payload.dateStart = dateToIsoString(new Date(payload.dateStart));
    if (payload.dateEnd) payload.dateEnd = dateToIsoString(new Date(payload.dateEnd));
    ApiDataBase.createMission(
      {
        token,
        ...payload,
      },
      (created) => {
        setIsLoadingAddMission(false);
        toast.success('La mission a bien été crée.');
        closeSlideOver();
      },
      (err) => {
        setIsLoadingAddMission(false);
        console.error('Error creating mission:', err);
      }
    );
  };

  const missionPages = [
    'Général',
    'Motif',
    'Planning',
    'Inviter / Notification',
    'Confirmation',
  ];

  return (
    <>
      <SlideOverHeader hide={closeSlideOver} hideShow={true}>
        <div className="flex gap-2">
          {missionPages.map((item, index) => (
            <div key={index} className="flex items-center gap-2">
              <Badge
                type={page === index + 1 ? 'WARNING' : 'SECONDARY'}
                size="LG"
                onClick={() => setPage(index + 1)}
              >
                {item}
              </Badge>
              {index < missionPages.length - 1 && (
                <ChevronRight wh={16} color="#374151" />
              )}
            </div>
          ))}
        </div>
      </SlideOverHeader>
      <SlideOverBody>
        <div className={'flex flex-col gap-6 text-sm'}>
          {page === 1 && <SlideOverAddMissionGeneral />}
          {page === 2 && <SlideOverAddMissionMotif />}
          {page === 3 && <SlideOverAddMissionPlanning />}
          {page === 4 && (
            <SlideOverAddMissionPlanningInvitationAttributionNotification />
          )}
          {page === 5 && <SlideOverAddMissionConfirmation setPage={setPage} />}
        </div>
      </SlideOverBody>
      <SlideOverFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={closeSlideOver}>
          Annuler
        </Button>
        {isLoadingAddMission ? (
          <Button size="LG" color="DISABLED">
            Création de la mission ...
          </Button>
        ) : (
          <>
            {page > 1 && (
              <Button
                size="LG"
                color="SECONDARY"
                onClick={() => setPage(page - 1)}
              >
                Précédent
              </Button>
            )}
            {page !== missionPages.length ? (
              <Button
                size="LG"
                color={canContinue ? 'PRIMARY' : 'DISABLED'}
                onClick={() => {
                  if (canContinue) {
                    setPage(page + 1);
                  }
                }}
                disabled={!canContinue}
              >
                Continuer
              </Button>
            ) : (
              <Button size="LG" color="PRIMARY" onClick={submitAddMission}>
                Confirmer
              </Button>
            )}
          </>
        )}
      </SlideOverFooter>
    </>
  );
};

export default slideOverAddMission;
